import isOutOfStock from './isOutOfStok';

const isAvailable = (
  // eslint-disable-next-line camelcase
  { unlimited, quantity }
) => !isOutOfStock({ unlimited, quantity });

export default isAvailable;
